import { createBoxVariantComponents } from '../setup-factories'

export const { BoxDesktopContent } = createBoxVariantComponents({
  DesktopContent: {
    display: 'block',
    breakpoints: {
      medium: {
        display: 'none'
      },
      small: {
        display: 'none'
      }
    }
  }
})
